<template>
  <v-card flat>

    <confirm-dialog
      :is-open="deleteDialog"
      :dialog-header="$t('deleteHeader')"
      :dialog-body="$t('deleteBody')"
      :is-loading="isLoading"
      :is-delete="true"
      :confirm-button-text="$t('delete')"
      @confirm="deleteEmployee"
      @dialogToggle="val => deleteDialog = val"
    />

    <v-card-text>
      <p>{{ $t('warnText') }}</p>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        :disabled="deleteDialog"
        color="error"
        @click.native="deleteDialog = true">
        {{ $t('delete') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import CompanyApi from '@/api/CompanyApi'
import ConfirmDialog from '@/components/global-components/confirmDialog/ConfirmDialog'
import { mapGetters } from 'vuex'

export default {
  name: 'EmployeeSettingsDeleteEmployee',
  components: { ConfirmDialog },
  data () {
    return {
      isLoading: false,
      deleteDialog: false
    }
  },
  computed: {
    ...mapGetters('employee', ['currentEmployee'])
  },
  methods: {
    deleteEmployeeByRole () {
      return CompanyApi.deleteEmployee(this.currentEmployee.id)
    },
    redirectToEmployeesByRole () {
      this.$router.push({ name: 'employees' })
    },
    async deleteEmployee () {
      try {
        this.isLoading = true
        const response = await this.deleteEmployeeByRole()
        this.$notification(response)
        this.redirectToEmployeesByRole()
      } catch (e) {
        this.$notification(e)
      }
      this.isLoading = false
    }
  },
  i18n: {
    messages: {
      en: {
        warnText: 'By removing the employee, all associated data such as timesheets, time tracking or settings for this employee are removed. ',
        delete: 'Delete',
        deleteHeader: 'Delete employee',
        deleteBody: 'Are you sure you want to delete the employee?'
      },
      tr: {
        warnText: 'Çalışanı kaldırdığınızda, bu çalışana ilişkin tüm zaman çizelgeleri, zaman takibi ve ayarlar kaldırılacaktır. ',
        delete: 'Sil',
        deleteHeader: 'Çalışanı sil',
        deleteBody: 'Bu çalışanı silmek istediğinize emin misiniz?'
      },
      de: {
        warnText: 'Durch entfernen des Mitarbeiters werden alle zugehörigen Daten wie Stundenzettel, Stechzeiten, Einstellungen für diesen Mitarbeiter entfernt. ',
        delete: 'Entfernen',
        deleteHeader: 'Mitarbeiter entfernen',
        deleteBody: 'Den Mitarbeiter wirklich entfernen?'
      },
      ru: {
        warnText: 'Удаляя сотрудника, все связанные данные, такие как табель, отслеживание времени или настройки для этого сотрудника, удаляются.',
        delete: 'Удалить',
        deleteHeader: 'Удалить сотрудника',
        deleteBody: 'Вы действительно хотите удалить сотрудника?'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
